/*
 * @Author: wuqinfa
 * @Date: 2022-10-12 18:15:49
 * @LastEditors: wuqinfa
 * @Description: axios请求封装
 */
import axios from 'axios';
// import qs from 'qs';

import {
  featchApiHeader,
  formApiHeader,
  baseApiUrl
} from './requestUtil.js';

const checkStatus = response => {
  const { code, message } = response.data;

  if (code && code !== '000001' && code !== '10000') {
    let errorInfo = '';
    switch (code) {
      case '000002':
        errorInfo = '用户校验不通过';
        break;
      case '000003':
        errorInfo = '操作失败';
        break;
      case '000004':
        errorInfo = '参数不合法';
        break;
      default:
        errorInfo = response.data.message;
        break;
    }

    return {
      success: false,
      message,
      errorInfo,
      code,
    };
  }
  return response.data;
};

// 创建axios实例
const instance = axios.create({
  baseURL: baseApiUrl,
  headers: featchApiHeader,
  timeout: 10000,
  withCredentials: true,
});

instance.interceptors.request.use(
  config => {
    if (config.method.toLowerCase() === 'post') {
      let newData = config.data;
      if (config.data instanceof FormData) {// 文件类
        config.timeout = 30000; // 上传文件，最长 30 秒
        Object.assign(config.headers, formApiHeader)
      }else{ // 非文件类
        // 暂时去掉空处理，恢复 data为qs.stringify(opt),时的入参
        // newData = (typeof newData == 'object' && Object.keys(newData).length >= 0) ? newData : {}; // 空处理
        // newData = { ...newData };
        // newData = qs.stringify(newData);
      }
      config.data = newData;
    }
    config.headers['pusher-token'] =   localStorage.getItem('pusher-token') || ''
    config.headers['mxc-token'] =   localStorage.getItem('mxc-token') || ''

    return config;
  },
  error => {
    return Promise.error(error);
  },
);

instance.interceptors.response.use(
  response => {
    return Promise.resolve(checkStatus(response));
  },
  error => {
    return Promise.reject(error);
  },
);

export default instance;



// WEBPACK FOOTER //
// ./src/utils/request.js